import * as Backbone from 'backbone';

import './NotFound.less';
import * as Template from './NotFound.jinja';

export default class NotFound extends Backbone.View {
    constructor(options = {}) {
        options.el = '.NotFound';
        options.VIEWS_TO_REGISTER = {};
        options.template = Template;
        super(options);

        app.els.$topNav.addClass('notFound');
        app.els.$content.addClass('notFound');
        app.els.$footer.addClass('notFound');
    }
}
